/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Category } from './Category'
import {
  CategoryFromJSON,
  CategoryFromJSONTyped,
  CategoryToJSON,
} from './Category'
import type { Article } from './Article'
import { ArticleFromJSON, ArticleFromJSONTyped, ArticleToJSON } from './Article'

/**
 *
 * @export
 * @interface BlogData
 */
export interface BlogData {
  /**
   *
   * @type {Array<Article>}
   * @memberof BlogData
   */
  articles: Array<Article>
  /**
   *
   * @type {Array<Category>}
   * @memberof BlogData
   */
  categories: Array<Category>
}

/**
 * Check if a given object implements the BlogData interface.
 */
export function instanceOfBlogData(value: object): value is BlogData {
  if (!('articles' in value) || value['articles'] === undefined) return false
  if (!('categories' in value) || value['categories'] === undefined)
    return false
  return true
}

export function BlogDataFromJSON(json: any): BlogData {
  return BlogDataFromJSONTyped(json, false)
}

export function BlogDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BlogData {
  if (json == null) {
    return json
  }
  return {
    articles: (json['articles'] as Array<any>).map(ArticleFromJSON),
    categories: (json['categories'] as Array<any>).map(CategoryFromJSON),
  }
}

export function BlogDataToJSON(value?: BlogData | null): any {
  if (value == null) {
    return value
  }
  return {
    articles: (value['articles'] as Array<any>).map(ArticleToJSON),
    categories: (value['categories'] as Array<any>).map(CategoryToJSON),
  }
}
